export class ContentApiConfiguration {
    rootUrl: string;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/configuration/content-api-configuration.model.ts